export class FormulaExpressaoValidationError extends Error {
    constructor(message: string, public readonly tokenIndex: number) {
        super(message);
    }
}
